import { IdCard, FileText, CreditCard, ShieldCheck, Info, Gavel, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const services = [
  {
    icon: <IdCard size={22} />,
    title: "Visa & Autorisation",
    desc: "Demandez votre visa ou autorisation d'entrée.",
    path: "#",
  },
  {
    icon: <FileText size={22} />,
    title: "Déclaration de voyage",
    desc: "Déclarez votre voyage entrant ou sortant.",
    path: "#",
  },
  {
    icon: <CreditCard size={22} />,
    title: "Carte de séjour",
    desc: "Demandez ou renouvelez votre carte de séjour.",
    path: "#",
  },
  {
    icon: <ShieldCheck size={22} />,
    title: "Assurance voyage",
    desc: "Souscrivez à une assurance pour votre sécurité.",
    path: "#",
  },
  {
    icon: <Info size={22} />,
    title: "Informations pays",
    desc: "Découvrez les infos utiles pour votre voyage au Niger.",
    path: "#",
  },
  {
    icon: <Gavel size={22} />,
    title: "Réglementations",
    desc: "Consultez les règles et conditions de voyage.",
    path: "#",
  },
];

export default function ServicesSection() {
  const navigate = useNavigate();

  const go = (path) => {
    if (!path || path === "#") return;
    navigate(path);
  };

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-48 lg:mt-52 py-8">
      <div className="flex items-end justify-between mb-5">
        <h2 className="text-xl md:text-2xl font-bold text-slate-800">Nos services</h2>
        <button
          onClick={() => go("#")}
          className="flex items-center gap-1 text-brand-600 hover:text-brand-700 text-sm font-semibold"
        >
          Voir tous les services <ArrowRight size={15} />
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {services.map((s, i) => (
          <button
            key={i}
            onClick={() => go(s.path)}
            className="group bg-white border border-slate-100 rounded-xl p-5 text-left transition-all hover:shadow-md hover:border-brand-100"
          >
            <div className="w-11 h-11 rounded-lg bg-brand-50 text-brand-600 flex items-center justify-center mb-3 group-hover:bg-brand-600 group-hover:text-white transition-colors">
              {s.icon}
            </div>
            <h3 className="font-bold text-slate-800 text-sm mb-1 leading-tight">{s.title}</h3>
            <p className="text-slate-500 text-xs leading-relaxed">{s.desc}</p>
            <div className="w-8 h-0.5 bg-brand-600 rounded-full mt-3" />
          </button>
        ))}
      </div>
    </section>
  );
}
